export type AgentExportType = 'MESSAGES' | 'RAW_EVENTS';

export interface AgentCurlOptions {
  apiUrl: string;
  token: string;
  exportType: AgentExportType;
  from: Date;
  to: Date;
  clientUuids: string[];
}

export function buildAgentExportCurl(options: AgentCurlOptions): string {
  const rawEvents = options.exportType === 'RAW_EVENTS';
  const endpoint = rawEvents ? '/api/admin/event/export' : '/api/admin/conversation/export';
  const filename = rawEvents ? 'raw-events.csv' : 'messages.csv';
  const argumentsWithContinuation = [
    `curl --fail --location --get ${shellQuote(options.apiUrl + endpoint)}`,
    `  --header ${shellQuote(`Authorization: Bearer ${options.token}`)}`,
    `  --data-urlencode ${shellQuote(`from=${options.from.toISOString()}`)}`,
    `  --data-urlencode ${shellQuote(`to=${options.to.toISOString()}`)}`,
    ...options.clientUuids.map(clientUuid =>
      `  --data-urlencode ${shellQuote(`clientUuid=${clientUuid}`)}`
    ),
    `  --output ${shellQuote(filename)}`
  ];

  return argumentsWithContinuation
    .map((argument, index) => index < argumentsWithContinuation.length - 1 ? `${argument} \\` : argument)
    .join('\n');
}

function shellQuote(value: string): string {
  return `'${value.replaceAll("'", `'"'"'`)}'`;
}
